import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const EthicsProLayout = lazy(() =>
  import('../components/ethics-pro/EthicsProLayout').then((m) => ({ default: m.EthicsProLayout }))
)
const EthProHubPage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.HubPage }))
)
const EthProCockpitPage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.CockpitPage }))
)
const EthProScorePage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.ScorePage }))
)
const EthProMaturitePage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.MaturitePage }))
)
const EthProPolitiquesPage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.PolitiquesPage }))
)
const EthProCodeConduitePage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.CodeConduitePage }))
)
const EthProComiteEthiquePage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.ComiteEthiquePage }))
)
const EthProFormationPage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.FormationPage }))
)
const EthProSignalementsPage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.SignalementsPage }))
)
const EthProAlertePage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.AlertePage }))
)
const EthProConflitInteretPage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.ConflitInteretPage }))
)
const EthProAntiCorruptionPage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.AntiCorruptionPage }))
)
const EthProCulturePage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.CulturePage }))
)
const EthProEnquetesPage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.EnquetesPage }))
)
const EthProDiversitePage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.DiversitePage }))
)
const EthProEsgPage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.EsgPage }))
)
const EthProFrameworksPage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.EthProFrameworksPage }))
)
const EthProIso37001Page = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.Iso37001Page }))
)
const EthProSapinIIPage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.SapinIIPage }))
)
const EthProCertificationPage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.CertificationPage }))
)
const EthProReportExecPage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.EthProReportExecPage }))
)
const EthProIntegrationPage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.EthProIntegrationPage }))
)
const EthProAuditTrailPage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.EthProAuditTrailPage }))
)
const EthProSettingsPage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.EthProSettingsPage }))
)
const EthProOutilsPage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.EthProOutilsPage }))
)
const EthProEsgFrameworksPage = lazy(() =>
  import('../pages/ethics-pro').then((m) => ({ default: m.EsgFrameworksPage }))
)

export const ethicsProRoutes: RouteObject[] = [
  {
    path: '/ethics-pro',
    element: <EthicsProLayout />,
    children: [
      { index: true, element: <EthProHubPage /> },

      { path: 'hub', element: <EthProHubPage /> },
      { path: 'cockpit', element: <EthProCockpitPage /> },
      { path: 'score', element: <EthProScorePage /> },
      { path: 'maturite', element: <EthProMaturitePage /> },
      { path: 'politiques', element: <EthProPolitiquesPage /> },
      { path: 'code-conduite', element: <EthProCodeConduitePage /> },
      { path: 'comite-ethique', element: <EthProComiteEthiquePage /> },
      { path: 'formation', element: <EthProFormationPage /> },
      { path: 'signalements', element: <EthProSignalementsPage /> },
      { path: 'alerte', element: <EthProAlertePage /> },
      { path: 'conflit-interet', element: <EthProConflitInteretPage /> },
      { path: 'anti-corruption', element: <EthProAntiCorruptionPage /> },
      { path: 'culture', element: <EthProCulturePage /> },
      { path: 'enquetes', element: <EthProEnquetesPage /> },
      { path: 'diversite', element: <EthProDiversitePage /> },
      { path: 'esg', element: <EthProEsgPage /> },
      { path: 'esg-frameworks', element: <EthProEsgFrameworksPage /> },
      { path: 'frameworks', element: <EthProFrameworksPage /> },
      { path: 'iso37001', element: <EthProIso37001Page /> },
      { path: 'sapin-ii', element: <EthProSapinIIPage /> },
      { path: 'certification', element: <EthProCertificationPage /> },
      { path: 'report-exec', element: <EthProReportExecPage /> },
      { path: 'integrations', element: <EthProIntegrationPage /> },
      { path: 'audit-trail', element: <EthProAuditTrailPage /> },
      { path: 'settings', element: <EthProSettingsPage /> },
      { path: 'outils', element: <EthProOutilsPage /> },
    ],
  },
]
